import { Box, Button, Checkbox, CloseButton, Divider, Grid, Group, Image, NumberInput, Switch, Tabs, Text, TextInput, Textarea, rem } from "@mantine/core";
import Modal, { Props as ModalProps } from "./Modal";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { client } from "../../lib/axiosClient";
import FormData from "form-data";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { IconCheck, IconPhoto, IconUpload, IconX, IconXboxX } from "@tabler/icons-react";
import { zodResolver } from 'mantine-form-zod-resolver';
import { z } from 'zod';
import { notifications } from "@mantine/notifications";

import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { useStore } from "../../api";

const cookies = new Cookies(null, { path: '/' });
type Props = {
    setSelectedData?: (id: string) => void;
    data?: any;
    refetchData?: () => void;
} & ModalProps;


export const UpdateRequestLimit = (props: Props) => {
    const { t } = useTranslation();
    const schema = z.object({
        numberRequest: z.number({required_error: t('modals.updateRequestLimit.schemaNumberRequest')}).gt(0, { message: t('modals.updateRequestLimit.schemaNumberRequest2') }),
        maxTime: z.number({required_error: t('modals.updateRequestLimit.schemaMaxTime')}).gt(0, { message: t('modals.updateRequestLimit.schemaMaxTime2') }),
    });
    const [loading, setLoading] = useState(false);
    const {onSubmit, reset, getInputProps, setValues, } = useForm({
        initialValues: {numberRequest: 0, maxTime: 0, enabled: false},
        validate: zodResolver(schema),
        validateInputOnBlur: true,
        validateInputOnChange: true
    });
    const {loading: loadingStore, error, data: dataStore, refetch} = useStore({
        idStore: cookies.get('id')
    })

    useEffect(() => {
        if (props.opened) {
            refetch()
        }
    }, [props.opened])

    useEffect(() => {
        if (dataStore && "requestLimit" in dataStore && dataStore.requestLimit !== null) {
            setValues({
                numberRequest: dataStore.requestLimit.numberRequest || 0,
                maxTime: dataStore.requestLimit.maxTime || 0,
                enabled: dataStore.requestLimit.enabled || false
            })
        }
    }, [dataStore])

    const onSubmitForm = ({numberRequest, maxTime, enabled}: any) => {
        setLoading(true)
        
        client.put(`/store/requests/${dataStore._id}`, {
            "numberRequest": numberRequest,
            "maxTime": maxTime,
            "enabled": enabled,
        }, {
            headers: {
                'Accept': 'application/json',
                'Authorization': cookies.get('token') || ""
            }
        })
        .then(({data}) => {
            notifications.show({ message: t('modals.updateRequestLimit.alert01'), color: '#fff' });
            console.log(data);
            setLoading(false)
            typeof props?.refetchData == "function" && props?.refetchData()
            closeModal()
        })
        .catch((error) => {
            notifications.show({ message: t('modals.updateRequestLimit.alert02'), color: '#fff' });
            console.log(error)
            setLoading(false)
        });
    }

    const closeModal = () => {
        reset();
        props.onClose();
        setLoading(false)
    };

    return (
        <Modal
            {...props} onClose={closeModal} loading={loading}
            footer={
                <Box py={16} px={20} bg="slate.0">
                    <Group justify={"flex-end"} gap={"xs"}>
                        <Button color={'gray'} variant="outline" rightSection={<IconX size={15} />} bg="white" onClick={closeModal}>{t('modals.cancelling')}</Button>
                        <Button color={'#323232'} rightSection={<IconCheck size={15} />} type="submit" form="submit_form">{t('modals.confirmation')}</Button>
                    </Group>
                </Box>
            }
        >
            <Box style={{padding: 20}}>
                <form onSubmit={onSubmit(onSubmitForm)} id="submit_form">
                    <Grid gutter={20} justify="flex-start">
                        <Grid.Col span={6} >
                            <NumberInput
                                label={t('modals.updateRequestLimit.label01')}
                                placeholder={t('modals.updateRequestLimit.placeholder01')}
                                withAsterisk
                                {...getInputProps("numberRequest")}
                            />
                        </Grid.Col>
                        <Grid.Col span={6} >
                            <NumberInput
                                label={t('modals.updateRequestLimit.label02')}
                                placeholder={t('modals.updateRequestLimit.placeholder02')}
                                withAsterisk
                                {...getInputProps("maxTime")}
                            />
                        </Grid.Col>
                        <Grid.Col span={6} >
                            <Switch
                                labelPosition="left"
                                label={t('modals.updateRequestLimit.label03')}
                                color={'#323232'}
                                styles={()=>({
                                    root: {
                                        background: "#fff",
                                        border: "1px solid #ced4da",
                                        borderRadius: 3,
                                        padding: "7px 10px"
                                    },
                                    body: { justifyContent: "space-between" },
                                    label: { paddingInlineStart: 0 }
                                })}
                                {...getInputProps("enabled", {type: "checkbox"})}
                            />
                        </Grid.Col>
                    </Grid>
                </form>
            </Box>
        </Modal>
    );
};